import { SettingService } from "@/services/nextshop/setting.service";

export default {
  methods: {
    async activeImeiByMerchant() {
      try {
        const response = await SettingService.getDataMerchant();
        if (response.success) {
          return response.data.merchant.itemMgmtMethod?.serialImei;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
